import React from 'react';

import {
  dateRangeMedWithZoneOffset,
  isDateTimeInFuture,
} from '../../helpers/dates';
import { OccationEventCard } from '../../helpers/list-page/interfaces/list-card.interface';
import { ILibraryMeetingPlaceDictionary } from '@/lib/fragments/libraryMeetingPlaceDictionary';
import { FavouriteButton } from '../ui/favourite-button/favourite-button';
import Link from 'next/link';
import { CardLogo } from './card-logo';
import Flame from '@assets/icons/Flame-listing.svg';

interface CardEventProps {
  card: OccationEventCard;
  cardIndex: number;
  dictionary?: ILibraryMeetingPlaceDictionary;
  fixedWidth?: boolean;
  bodyMinHeight?: string;
  isLivliFamily?: boolean;
}

export const CardEvent = ({
  card,
  cardIndex,
  dictionary,
  fixedWidth = false,
  bodyMinHeight,
  isLivliFamily = false,
}: CardEventProps) => {
  return (
    <div className="relative h-full">
      <Link
        href={card?.slug}
        key={card?.id}
        className={`group flex h-full cursor-pointer flex-col overflow-hidden rounded-xl focus:outline focus:outline-3 focus:outline-offset-3 focus:outline-text-light bg-background-primary-light transition-all lg:hover:bg-background-secondary ${fixedWidth && 'w-[316px]'}`}
      >
        <div className="" style={{ zIndex: '1' }}>
          <CardLogo
            card={card}
            className="!absolute top-5 left-5 w-16 h-16 bg-brand-white rounded-[12px] sm:rounded-lg flex items-center justify-center"
          />
        </div>
        {card?.image?.url && (
          <div className="image-box relative rounded-xl overflow-hidden bg-background-primary-light transition-all lg:hover:bg-background-secondary">
            {/* Blurred background layer */}
            <img
              src={card.image.url + '?fm=avif&q=50'}
              alt={card?.image?.alt || 'alt text not found'}
              aria-hidden="true"
              className="absolute inset-0 h-full w-full object-cover scale-110 will-change-transform pointer-events-none"
              style={{ filter: 'blur(10px) brightness(0.8)' }}
            />
            {/* contained image on top */}
            <img
              src={card.image.url + '?fm=avif&q=50'}
              alt={card?.image?.alt || 'alt text not found'}
              className="absolute inset-0 h-full w-full object-contain"
            />
          </div>
        )}

        <div
          style={bodyMinHeight ? { minHeight: bodyMinHeight } : undefined}
          className="flex flex-1 flex-col flex-wrap rounded-b-xl bg-background-primary-light px-6 py-5 transition-all duration-200 lg:group-hover:bg-background-secondary"
        >
          <div className="mb-auto">
            {isLivliFamily && card?.slots && (
              <div className="font-sans text-bodym text-neutral-grey-700 font-bold flex items-center gap-2">
                {card?.slots?.variant == 'Today' ? (
                  <>
                    <Flame /> {dictionary?.today ?? 'Today'}
                  </>
                ) : (
                  dictionary?.nextEvent + ':' + ' ' + card?.slots?.date
                )}
              </div>
            )}
            <div className="mb-1 mt-1 min-h-[20px] text-bodym text-text-light">
              {dateRangeMedWithZoneOffset(
                card?.startDate?.toString(),
                card?.endDate?.toString(),
                card?.node_locale,
              )}
            </div>

            <h2
              className={`mb-2 mt-2 line-clamp-3 min-h-[42px] overflow-hidden text-ellipsis font-title text-bodyxl leading-[1.2] font-bold text-text-default transition-all duration-200 ease-in-out
          `}
            >
              {card?.name}
            </h2>
            <div className="flex flex-wrap gap-2">
              {card?.endDate &&
                !isDateTimeInFuture(card?.endDate.toString(), '') && (
                  <span className="flex-shrink-0 rounded-[4px] border-2 border-brand-red-2 bg-brand-red-1 px-2 text-bodyxs font-bold text-text-sticker-red">
                    {dictionary?.pastEvent}
                  </span>
                )}
              {card?.eventTypes &&
                card?.endDate &&
                isDateTimeInFuture(card?.endDate.toString(), '') &&
                // card?.eventTypes?.filter(Boolean)?.map((eventType, key) => (
                [...(card?.eventTypes?.filter(Boolean) ?? [])]
                  .sort((a, b) => {
                    if (a?.name === 'Livli Family') return -1;
                    if (b?.name === 'Livli Family') return 1;
                    return 0;
                  })
                  .map((eventType, key) => (
                    <span
                      key={key}
                      className={`flex-shrink-0 rounded-[4px] border-2  bg-background-primary-light px-2 text-bodyxs font-bold text-text-default ${eventType?.name == 'Livli Family' ? 'border-brand-yellow-2' : 'border-neutral-grey-200'}`}
                    >
                      {eventType?.name}
                    </span>
                  ))}
            </div>
          </div>
        </div>
      </Link>
      <FavouriteButton
        id={card.id}
        type="event"
        className="absolute top-5 right-5 z-1 h-12 w-12"
        iconclass="h-6 w-6"
        name={card?.name}
      />
    </div>
  );
};
